/**
 * Bluebox Salary.js onChangedDeclareren.
 * Ja selects Question2 aid 2 (Vergoedingen door Vervangingsfonds) and hides the rest.
 * Nee hides aid 2 and clears the current selection.
 */
export const VERVANGINGSFONDS_FINANCIERINGSBRON = '2';

export const applyDeclarerenFinancieringsbron = (draft, fieldId, value) => {
    const next = {
        ...draft,
        [fieldId]: value,
    };

    if (fieldId !== 'declarerenVf') {
        return next;
    }

    if (value === 'yes') {
        next.financieringsbron = VERVANGINGSFONDS_FINANCIERINGSBRON;
        return next;
    }

    if (value === 'no') {
        next.financieringsbron = '';
    }

    return next;
};

export const syncFinancieringsbronForDeclareren = (draft = {}) => {
    if (draft.declarerenVf === 'yes') {
        return {
            ...draft,
            financieringsbron: VERVANGINGSFONDS_FINANCIERINGSBRON,
        };
    }

    if (draft.declarerenVf === 'no' && String(draft.financieringsbron ?? '') === VERVANGINGSFONDS_FINANCIERINGSBRON) {
        return {
            ...draft,
            financieringsbron: '',
        };
    }

    return draft;
};

export const filterFinancieringsbronOptions = (options, declarerenVf) => {
    if (!Array.isArray(options)) {
        return options;
    }

    if (declarerenVf === 'yes') {
        return options.filter(
            (option) => String(option.value ?? '') === VERVANGINGSFONDS_FINANCIERINGSBRON,
        );
    }

    if (declarerenVf === 'no') {
        return options.filter(
            (option) => String(option.value ?? '') !== VERVANGINGSFONDS_FINANCIERINGSBRON,
        );
    }

    return options;
};
